import { Link } from "react-router-dom";
import { Instagram, Music2 } from "lucide-react";
import { LOGOS, NAV_LINKS, CONTACT } from "../data/site";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#151313] py-14 sm:py-20"
    >
      <div className="mx-auto flex max-w-[1400px] flex-col gap-12 px-6 sm:px-10 md:flex-row md:items-start md:justify-between">
        <div className="shrink-0">
          <img src={LOGOS.yellow} alt="Chicken Labb" className="h-16 w-auto sm:h-20" />
        </div>

        <div className="flex flex-col gap-10 sm:flex-row sm:gap-20">
          <div className="flex flex-col gap-3">
            {NAV_LINKS.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                className="font-mono text-xs uppercase tracking-widest text-offwhite transition-colors hover:text-labyellow"
              >
                {l.label}
              </Link>
            ))}
          </div>

          <div className="flex flex-col gap-3">
            <p className="font-mono text-xs uppercase tracking-widest text-labyellow">Contact</p>
            <p className="font-body text-sm text-offwhite/80">{CONTACT.address}</p>
            <p className="font-body text-sm text-offwhite/80">{CONTACT.phone}</p>
            <div className="mt-2 flex gap-4">
              <a href="https://instagram.com" target="_blank" rel="noreferrer" aria-label="Instagram" data-testid="footer-instagram" className="text-offwhite transition-colors hover:text-labyellow">
                <Instagram className="h-5 w-5" />
              </a>
              <a href="https://tiktok.com" target="_blank" rel="noreferrer" aria-label="TikTok" data-testid="footer-tiktok" className="text-offwhite transition-colors hover:text-labyellow">
                <Music2 className="h-5 w-5" />
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="mx-auto mt-14 flex max-w-[1400px] flex-col gap-3 border-t border-white/10 px-6 pt-6 sm:flex-row sm:items-center sm:justify-between sm:px-10">
        <p className="font-body text-xs text-offwhite/50">© 2026 Chicken Labb. All rights reserved.</p>
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-labyellow">FLAVOR, ENGINEERED.</p>
      </div>
    </footer>
  );
};
